import type { ReservationModeLabels } from '@iheartjane/types';
import capitalize from 'lodash-es/capitalize';

export const getReservationModeLabel = (
  reservationMode: 'pickup' | 'delivery' | 'curbside' | 'retail' | 'kiosk',
  customLabels?: ReservationModeLabels | null,
  defaultLabels?: Partial<ReservationModeLabels>
): string => {
  const label = capitalize(reservationMode);

  //we don't support custom labels for kiosk or retail modes
  if (reservationMode === 'kiosk' || reservationMode === 'retail') {
    return label;
  }

  const customLabel = customLabels && customLabels[reservationMode];
  const defaultLabel = defaultLabels && defaultLabels[reservationMode];

  return customLabel || defaultLabel || label;
};

export const getReservationModeLabels = (
  customLabels?: ReservationModeLabels | null
) => ({
  pickupLabel: getReservationModeLabel('pickup', customLabels),
  deliveryLabel: getReservationModeLabel('delivery', customLabels),
  curbsideLabel: getReservationModeLabel('curbside', customLabels),
});
